module.exports = __webpack_public_path__ + "img/audit-and-analyze.afcabb14.jpg";